module.exports = __webpack_public_path__ + "static/media/box-pink.ba63929d.svg";